import Upsertable from '@/models/Upsertable'
import { useDemographicStore } from '@/stores/demographicStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class Demographic extends Upsertable {
  static store() {
    return useDemographicStore()
  }

  store() {
    return Demographic.store()
  }

  static all() {
    return Demographic.store().getAll
  }

  get_birth_date() {
    return this.birthdate
  }

  static find(uuid) {
    const obj = Demographic.store().find(uuid)
    let demographic = new Demographic()
    return Object.assign(demographic, obj)
  }

  get_identity_number() {
    let identity_number = ''
    if (this.identity_number != undefined) {
      identity_number = this.identity_number
    } else {
      identity_number = this.nin_number
    }
    return identity_number
  }

  beforeSave() {
    //Update name cache , etc
    this.identity_number_cache = this.get_identity_number()
  }

  afterSave() {
    //Update name cache , etc
  }
}

useModelName(Demographic, "Demographic")
ModelRegistry.register(Demographic, "Demographic")